import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  AdministrationLoadEditService,
  AdminLoadModel,
  CustomerLoadAddRequest,
  AdminLoadPriceRequest,
  AdminLoadListModel,
  LoadBoardSortRequest,
  CustomerLoadDetailsRequest,
  CustomerLoadEditStopsRequest,
  LoadStatus,
  AdminLoadOvnExportRequest,
  AnyValueModelLocalDateTime
} from '../autogenerated';
import { REQUEST_OPTIONS } from '../constants';
import { RequestOptionsJsonType, RequestOptionsVoidType } from '../types';

@Injectable({ providedIn: 'root' })
export class AdministrationLoadEditApiService {
  constructor(private apiService: AdministrationLoadEditService) {}

  public addLoad(customerId: string, userId: string, body: CustomerLoadAddRequest, post?: boolean, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<AdminLoadModel> {
    return this.apiService.adminLoadAdd(customerId, userId, body, post, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public removeFromBoard(loadId: string, requestOptions: RequestOptionsVoidType = REQUEST_OPTIONS): Observable<void> {
    return this.apiService.adminLoadBoardArchive(loadId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public cancelLoadAfterPickup(loadId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<AdminLoadModel> {
    return this.apiService.adminLoadCancelAfterPickup(loadId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public setLoadPrice(loadId: string, body: AdminLoadPriceRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<AdminLoadModel> {
    return this.apiService.adminLoadCancelPermanently(loadId, body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public cancelLoadPermanently(loadId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<AdminLoadModel> {
    return this.apiService.adminLoadCancelPermanently1(loadId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public deleteLoad(loadId: string, requestOptions: RequestOptionsVoidType = REQUEST_OPTIONS): Observable<void> {
    return this.apiService.adminLoadDelete(loadId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public setBoardSort(body: LoadBoardSortRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<AdminLoadListModel> {
    return this.apiService.adminLoadEditBoardSortOrder(body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public editLoadDetails(loadId: string, body: CustomerLoadDetailsRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<AdminLoadModel> {
    return this.apiService.adminLoadEditDetails(loadId, body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public setPlannedRoute(loadId: string, value: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<AdminLoadModel> {
    return this.apiService.adminLoadEditDirectionData(loadId, { value }, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public editLoadDraft(loadId: string, body: CustomerLoadAddRequest, post?: boolean, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<AdminLoadModel> {
    return this.apiService.adminLoadEditDraft(loadId, body, post, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public editLoadDriver(loadId: string, driverId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<AdminLoadModel> {
    return this.apiService.adminLoadEditDriver(loadId, driverId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public editRoute(loadId: string, body: CustomerLoadEditStopsRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<AdminLoadModel> {
    return this.apiService.adminLoadEditRoute(loadId, body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public editLoadStatus(loadId: string, status: LoadStatus, loadRequestId?: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<AdminLoadModel> {
    return this.apiService.adminLoadEditStatus(loadId, status, loadRequestId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public markLoadAsPaid(loadId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<AdminLoadModel> {
    return this.apiService.adminLoadMarkPaid(loadId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public exportLoadToOvn(loadId: string, body: AdminLoadOvnExportRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<AdminLoadModel> {
    return this.apiService.adminLoadOvnExport(loadId, body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public rejectLoadRequest(loadId: string, requestId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<AdminLoadModel> {
    return this.apiService.adminLoadRejectRequest(loadId, requestId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public schedulePostDraft(loadId: string, anyValueModelLocalDateTime: AnyValueModelLocalDateTime, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<AdminLoadModel> {
    return this.apiService.adminLoadSchedulePost(loadId, anyValueModelLocalDateTime, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public setStopGood_to_go(loadId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<AdminLoadModel> {
    return this.apiService.adminLoadStopGoodToGo(loadId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public editAssist(loadId: string, assist: boolean, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<AdminLoadModel> {
    return this.apiService.adminLoadSwitchAssist(loadId, assist, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public unschedulePostDraft(loadId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<AdminLoadModel> {
    return this.apiService.adminLoadUnschedulePost(loadId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
}
